import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FlowAccessService {
  private allowedUrl: string | null = null;
  private expiresAt?: number;

  // Concede permiso para una única URL
  allow(url: string, ttlMillis?: number) {
    this.allowedUrl = this.normalize(url);
    this.expiresAt = ttlMillis ? Date.now() + ttlMillis : undefined;
    sessionStorage.setItem('flow-permission:url', this.allowedUrl);
    sessionStorage.setItem('flow-permission:expires', this.expiresAt ? String(this.expiresAt) : '');
  }

  // Consume si coincide exactamente y no expiró
  consume(url: string): boolean {
    this.loadFromSession(); // asegura estado tras F5
    if (!this.allowedUrl) return false;
    const norm = this.normalize(url);
    if (this.expiresAt && Date.now() > this.expiresAt) {
      this.clear();
      return false;
    }
    if (norm === this.allowedUrl) {
      return true;
    }
    return false;
  }

  clear() {
    this.allowedUrl = null;
    this.expiresAt = undefined;
    sessionStorage.removeItem('flow-permission:url');
    sessionStorage.removeItem('flow-permission:expires');
  }

  private loadFromSession() {
    if (this.allowedUrl) return; // ya cargado
    const url = sessionStorage.getItem('flow-permission:url');
    const exp = sessionStorage.getItem('flow-permission:expires');
    this.allowedUrl = url || null;
    this.expiresAt = exp ? Number(exp) : undefined;
  }

  private normalize(url: string): string {
    const segments = url.split('#')[0].split('?')[0].split('/').filter(s => s.length > 0);
    const localePattern = /^[a-z]{2}(?:-[A-Z]{2})?$/;

    if (segments.length > 0 && localePattern.test(segments[0])) {
      segments.shift(); // elimina el locale dinámico
    }
    return '/' + segments.join('/');
  }
}
